import VideoPlayer from '@zvuk-b2b/react-uikit/ui/VideoPlayer';
import React from 'react';
import styles from '../index.module.scss';

interface IVideoPreview {
  url: string;
}

export const VideoPreview: React.FC<IVideoPreview> = ({ url }) => (
  <div>
    <VideoPlayer
      className={styles.content}
      width="auto"
      height="auto"
      url={url}
      loop={false}
    />
  </div>
);
